import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const EASE = [0.16, 1, 0.3, 1] as const;

const faqs = [
  { question: "L'agent IA va-t-il remplacer mon coaching ?", answer: "Non, vous gardez la main sur votre coaching. L'agent IA accélère ce qui vous ralentit — génération de programmes, priorisation, brouillons de réponse — pendant que vous gardez la main sur les décisions, la relation client et la qualité de l'accompagnement." },
  { question: "Est-ce utile si j'ai encore peu de clients ?", answer: "Oui, surtout si vous voulez structurer votre activité tôt. Une fiche client claire, des programmes rangés et des relances propres sont utiles dès les premiers suivis." },
  { question: "Mes clients ont-ils une expérience mobile ?", answer: "Oui. CoachOS inclut une expérience mobile côté coach et côté client : messages, progression, séances et informations importantes." },
  { question: "Comment se passe la démo ?", answer: "On part de votre manière actuelle de suivre vos clients, puis on montre les parcours utiles : création de programme, dossier client, messages, alertes et apps mobiles." },
];

const FAQ = () => {
  return (
    <section id="faq" className="relative z-10 overflow-hidden py-16 md:py-24 " style={{ background: "var(--landing-soft, #F5F7FC)" }}>
      <div className="container relative z-10 grid items-start gap-10 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: EASE }}
          className="max-w-sm"
        >
          <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-[#2563EB]">FAQ</p>
          <h2 className="landing-section-title text-3xl font-extrabold leading-tight tracking-tight text-[#0e1220] md:text-5xl">
            Questions{" "}
            <span className="text-[#2563EB]">fréquentes.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[#0e1220]/60">Tout ce qu’il faut savoir avant de vous lancer.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ delay: 0.1, ease: EASE }}
          className="min-w-0"
        >
          <Accordion type="single" collapsible className="border-t border-[#dfe4ed]">
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.question}
                value={faq.question}
                className="border-b border-[#dfe4ed] py-2 transition-colors data-[state=open]:border-[#2563EB]/40"
              >
                <AccordionTrigger className="text-left text-base font-semibold text-[#0e1220] hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="leading-relaxed text-[#0e1220]/65">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
